import { render, staticRenderFns } from "./CargoOccurrenceAttachments.vue?vue&type=template&id=34817b04"
import script from "./CargoOccurrenceAttachments.vue?vue&type=script&lang=js"
export * from "./CargoOccurrenceAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports